/* eslint-disable quotes, quote-props, comma-dangle  */

const translations = {
  "loading-label": [{
    "type": 0,
    "value": "Cargando"
  }]
};
function TranslationProviderComponent({
  children
}) {
  return children(translations);
}
var esCO = Object.assign(TranslationProviderComponent, {
  translations
});

export { esCO as e };
//# sourceMappingURL=es-CO-DA6enhMu.js.map
